import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { DotsDirectivesModule } from '@uzurv/dots';
import { FavoriteDriversListItemComponent } from './favorite-drivers-list-item';

@NgModule({
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, MatListModule, DotsDirectivesModule],
  declarations: [FavoriteDriversListItemComponent],
  exports: [FavoriteDriversListItemComponent]
})
export class FavoriteDriversModule {}
